import { configureStore, type ReducersMapObject } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';

/**
 * 创建应用 Redux Store 的配置选项
 */
export interface CreateStoreConfig {
  /** 额外的 reducer（用于业务模块扩展） */
  additionalReducers?: ReducersMapObject;
}

/**
 * 创建应用 Redux Store
 * 
 * @param config 配置选项
 * @returns 配置好的 Redux store
 */
export function createStore(config?: CreateStoreConfig) {
  const reducers: ReducersMapObject = {
    auth: authReducer,
    ...(config?.additionalReducers || {}),
  };

  return configureStore({
    reducer: reducers,
  });
}

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

